import React, { useEffect, useState, useRef } from 'react';
import baseURL from '../url';
import './Products.css';
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper/core';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight, faHeart, faShoppingCart, faStar, faStarHalfAlt, faExclamationTriangle, faCheck, faPalette, faRuler } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import ProductosLoading from '../ProductosLoading/ProductosLoading';
import { Link as Anchor } from "react-router-dom";
import moneda from '../moneda';

SwiperCore.use([Navigation, Pagination, Autoplay]);

export default function Products() {
    const [categorias, setCategorias] = useState([]);
    const [loading, setLoading] = useState(true);
    const [fixedCategories, setFixedCategories] = useState(false);
    const categoriasRefs = useRef([]);
    const categoriasInputRef = useRef(null);
    const swiperRef = useRef(null);
    const [productos, setProductos] = useState([]);
    const [categoriaSeleccionada, setCategoriaSeleccionada] = useState('Todo');
    const [favoritos, setFavoritos] = useState([]);
    const [productosConVariaciones, setProductosConVariaciones] = useState([]);
    const [cart, setCart] = useState([]);

    // Cargar favoritos y carrito desde localStorage
    useEffect(() => {
        const favoritosGuardados = localStorage.getItem('favoritos');
        if (favoritosGuardados) {
            setFavoritos(JSON.parse(favoritosGuardados));
        }

        const carritoGuardado = localStorage.getItem('cart');
        if (carritoGuardado) {
            setCart(JSON.parse(carritoGuardado));
        }
    }, []);

    const handleClickCategoria = (categoria) => {
        setCategoriaSeleccionada(categoria);
    };

    const toggleFavorito = (idProducto, event) => {
        event.preventDefault();
        event.stopPropagation();

        const nuevosFavoritos = favoritos.includes(idProducto)
            ? favoritos.filter(id => id !== idProducto)
            : [...favoritos, idProducto];

        setFavoritos(nuevosFavoritos);
        localStorage.setItem('favoritos', JSON.stringify(nuevosFavoritos));

        toast.success(
            favoritos.includes(idProducto) ? 'Eliminado de favoritos' : 'Agregado a favoritos',
            { autoClose: 1000 }
        );
    };

    useEffect(() => {
        cargarProductos();
        cargarCategorias();

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const handleScroll = () => {
        if (categoriasInputRef.current) {
            if (window.scrollY > categoriasInputRef.current.offsetTop) {
                setFixedCategories(true);
            } else {
                setFixedCategories(false);
            }
        }
    };

    const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setProductos(data.productos);
                setLoading(false);
                // Cargar variaciones después de cargar productos
                if (data.productos && data.productos.length > 0) {
                    cargarVariacionesProductos(data.productos);
                }
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };

    const cargarCategorias = () => {
        fetch(`${baseURL}/categoriasGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCategorias(data.categorias || []);
            })
            .catch(error => console.error('Error al cargar categorías:', error));
    };

    const cargarVariacionesProductos = async (listaProductos) => {
        console.log('Cargando variaciones para', listaProductos.length, 'productos');

        const productosConDatos = await Promise.all(
            listaProductos.map(async (producto) => {
                try {
                    const response = await fetch(`${baseURL}/productoDetalleGet.php?idProducto=${producto.idProducto}`);
                    const data = await response.json();

                    console.log(`Datos para producto ${producto.idProducto}:`, data);

                    if (!data.error && data.colores && data.colores.length > 0) {
                        // Calcular stock total
                        const stockTotal = data.colores.reduce((total, color) => {
                            return total + color.tallas.reduce((subtotal, talla) => subtotal + parseInt(talla.stock || 0), 0);
                        }, 0);

                        // Obtener colores únicos con sus hex - ajustado para tu API
                        const coloresUnicos = data.colores.map(color => ({
                            color: color.color,
                            hex: color.colorHex || color.codigo_color || '#000000'
                        }));

                        console.log(`Producto ${producto.titulo} - Stock: ${stockTotal}, Colores:`, coloresUnicos);

                        return {
                            ...producto,
                            colores: coloresUnicos,
                            stockTotal: stockTotal,
                            variacionesCompletas: data.colores
                        };
                    }
                    return {
                        ...producto,
                        colores: [],
                        stockTotal: 0,
                        variacionesCompletas: []
                    };
                } catch (error) {
                    console.error(`Error cargando variaciones para producto ${producto.idProducto}:`, error);
                    return {
                        ...producto,
                        colores: [],
                        stockTotal: 0,
                        variacionesCompletas: []
                    };
                }
            })
        );

        console.log('Productos con variaciones:', productosConDatos);
        setProductosConVariaciones(productosConDatos);
    };

    // Función para agregar al carrito
    const agregarAlCarrito = (item, event) => {
        event.preventDefault();
        event.stopPropagation();

        // Si no tiene variaciones, mostrar mensaje para ir a detalles
        if (!item.variacionesCompletas || item.variacionesCompletas.length === 0) {
            toast.info('Ve a los detalles del producto para seleccionar opciones', { autoClose: 2000 });
            return;
        }

        // Encontrar la primera variación disponible
        let colorSeleccionado = null;
        let tallaSeleccionada = null;

        for (const color of item.variacionesCompletas) {
            const tallaConStock = color.tallas.find(talla => parseInt(talla.stock) > 0);
            if (tallaConStock) {
                colorSeleccionado = color;
                tallaSeleccionada = tallaConStock;
                break;
            }
        }

        if (!colorSeleccionado || !tallaSeleccionada) {
            toast.error('Producto sin stock disponible', { autoClose: 1000 });
            return;
        }

        // Verificar si ya existe en el carrito
        const existingItemIndex = cart.findIndex(cartItem =>
            cartItem.idProducto === item.idProducto &&
            cartItem.idProductoColor === colorSeleccionado.idProductoColor &&
            cartItem.idProductoTalla === tallaSeleccionada.idProductoTalla
        );

        const newCart = [...cart];

        if (existingItemIndex !== -1) {
            const newQuantity = newCart[existingItemIndex].cantidad + 1;
            if (newQuantity > parseInt(tallaSeleccionada.stock)) {
                toast.error('No hay suficiente stock', { autoClose: 1000 });
                return;
            }
            newCart[existingItemIndex].cantidad = newQuantity;
        } else {
            newCart.push({
                idProducto: item.idProducto,
                idProductoColor: colorSeleccionado.idProductoColor,
                idProductoTalla: tallaSeleccionada.idProductoTalla,
                titulo: item.titulo,
                color: colorSeleccionado.color,
                talla: tallaSeleccionada.talla,
                precio: item.precio,
                imagen: obtenerImagen(item),
                cantidad: 1,
                stockDisponible: parseInt(tallaSeleccionada.stock)
            });
        }

        setCart(newCart);
        localStorage.setItem('cart', JSON.stringify(newCart));

        toast.success(`Agregado al carrito: ${colorSeleccionado.color} - Talla ${tallaSeleccionada.talla}`, {
            autoClose: 2000
        });
    };

    const obtenerImagen = (item) => {
        if (item.imagen1) return item.imagen1;
        if (item.imagenPrincipal) return item.imagenPrincipal;
        if (item.imagen2) return item.imagen2;
        if (item.imagen3) return item.imagen3;
        if (item.imagen4) return item.imagen4;
        return null;
    };

    // Función para obtener colores disponibles (datos reales)
    const obtenerColoresProducto = (item) => {
        return item.colores || [];
    };

    // Función para obtener tallas disponibles (datos reales)
    const obtenerTallasProducto = (item) => {
        if (!item.variacionesCompletas || item.variacionesCompletas.length === 0) return [];
        
        const tallasUnicas = [];
        item.variacionesCompletas.forEach(color => {
            color.tallas?.forEach(talla => {
                if (parseInt(talla.stock) > 0 && !tallasUnicas.includes(talla.talla)) {
                    tallasUnicas.push(talla.talla);
                }
            });
        });
        return tallasUnicas;
    };

    // Función para obtener stock disponible (datos reales)
    const obtenerStock = (item) => {
        return item.stockTotal || 0;
    };

    // Función para obtener características del producto
    const obtenerCaracteristicas = (item) => {
        const caracteristicas = [];
        if (item.categoriaNombre) caracteristicas.push(item.categoriaNombre);
        if (item.masVendido === "si") caracteristicas.push("Más Vendido");
        if (item.precioAnterior > item.precio) caracteristicas.push("Oferta");
        if (item.tela) caracteristicas.push(item.tela);
        return caracteristicas.slice(0, 3);
    };

    // Usar productos con variaciones cuando estén disponibles, sino usar productos originales
    const productosParaMostrar = productosConVariaciones.length > 0 ? productosConVariaciones : productos;

    const categoriasConProductos = categorias.filter(categoria =>
        productosParaMostrar?.some(producto => producto?.idCategoria === categoria?.idCategoria)
    );

    // Componente de tarjeta mejorada
    const ProductCard = ({ item, isMasVendido = false }) => {
        const colores = obtenerColoresProducto(item);
        const tallas = obtenerTallasProducto(item);
        /* const rating = obtenerRating(item); */
        const stock = obtenerStock(item);
        const caracteristicas = obtenerCaracteristicas(item);
        const descuento = item.precioAnterior > item.precio ?
            Math.round(((item.precioAnterior - item.precio) / item.precioAnterior) * 100) : 0;

        return (
            <div className={`product-card-improved ${isMasVendido ? 'mas-vendido-card' : ''}`}>
                <div className="card-image-container-improved">
                    <img src={obtenerImagen(item)} alt={item.titulo} className="card-image-improved" />

                    {isMasVendido && <div className="badge-improved">Más Vendido</div>}
                    {descuento > 0 && <div className="discount-badge-improved">-{descuento}%</div>}

                    <button
                        className="favorite-btn-improved"
                        onClick={(e) => toggleFavorito(item.idProducto, e)}
                    >
                        <FontAwesomeIcon
                            icon={faHeart}
                            style={{
                                color: favoritos.includes(item.idProducto) ? '#e74c3c' : '#57606f',
                                opacity: favoritos.includes(item.idProducto) ? 1 : 0.5
                            }}
                        />
                    </button>
                </div>

                <div className="card-content-improved">
                    <h3 className="product-title-improved">{item.titulo}</h3>
                   {/*  {item.descripcion && (
                        <p className="product-description-improved">{item.descripcion}</p>
                    )} */}

                    {/* Variaciones */}
                    {(colores.length > 0 || tallas.length > 0) && (
                        <div style={{ margin: '8px 0', fontSize: 12 }}>
                            {/* Colores */}
                            {colores.length > 0 && (
                                <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
                                    <FontAwesomeIcon icon={faPalette} style={{ color: '#6b7280', fontSize: 10 }} />
                                    <span style={{ color: '#6b7280' }}>
                                        {colores.length} color{colores.length !== 1 ? 'es' : ''}:
                                    </span>
                                    <div style={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
                                        {colores.slice(0, 4).map((color, idx) => (
                                            <div
                                                key={idx}
                                                style={{
                                                    width: 12,
                                                    height: 12,
                                                    borderRadius: '50%',
                                                    backgroundColor: color.hex,
                                                    border: '1px solid #d1d5db',
                                                    flexShrink: 0
                                                }}
                                                title={color.color}
                                            />
                                        ))}
                                        {colores.length > 4 && (
                                            <span style={{ fontSize: 10, color: '#6b7280' }}>
                                                +{colores.length - 4}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            )}
                            
                            {/* Tallas */}
                            {tallas.length > 0 && (
                                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                    <FontAwesomeIcon icon={faRuler} style={{ color: '#6b7280', fontSize: 10 }} />
                                    <span style={{ color: '#6b7280' }}>
                                        {tallas.length} talla{tallas.length !== 1 ? 's' : ''}:
                                    </span>
                                    <div style={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                                        {tallas.slice(0, 6).map((talla, idx) => (
                                            <span
                                                key={idx}
                                                style={{
                                                    fontSize: 9,
                                                    background: '#f3f4f6',
                                                    color: '#374151',
                                                    padding: '1px 4px',
                                                    borderRadius: 3,
                                                    border: '1px solid #e5e7eb'
                                                }}
                                            >
                                                {talla}
                                            </span>
                                        ))}
                                        {tallas.length > 6 && (
                                            <span style={{ fontSize: 9, color: '#6b7280' }}>
                                                +{tallas.length - 6}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    )}

                    {caracteristicas.length > 0 && (
                        <div className="product-features-improved">
                            {caracteristicas.map((caracteristica, index) => (
                                <span key={index} className="feature-tag-improved">
                                    {caracteristica}
                                </span>
                            ))}
                        </div>
                    )}

                    <div className="price-section-improved">
                        <div className="price-container-improved">
                            <span className="current-price-improved">
                                {moneda} {String(item?.precio)?.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                            </span>
                            {item.precioAnterior > item.precio && (
                                <span className="original-price-improved">
                                    {moneda} {String(item?.precioAnterior)?.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                </span>
                            )}
                        </div>

                        <div className="stock-info-improved">
                            {stock === 0 ? (
                                <span className="stock-low-improved">
                                    <FontAwesomeIcon icon={faExclamationTriangle} />
                                    Sin stock
                                </span>
                            ) : stock <= 5 ? (
                                <span className="stock-low-improved">
                                    <FontAwesomeIcon icon={faExclamationTriangle} />
                                    ¡Solo quedan {stock}!
                                </span>
                            ) : (
                                <span className="stock-available-improved">
                                    <FontAwesomeIcon icon={faCheck} />
                                    En stock ({stock}+)
                                </span>
                            )}
                            <span className="sku-improved">SKU: {item.idProducto}</span>
                        </div>

                        <div className="card-actions-improved">
                            <Anchor
                                to={`/producto/${item.idProducto}/${item.titulo.replace(/\s+/g, '-')}`}
                                className="btn-view-details-improved"
                            >
                                Ver detalles
                            </Anchor>

                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className='ProductsContain'>
            {productos?.length > 0 && (
                <div className={`categoriasInputs ${fixedCategories ? 'fixed' : ''}`} ref={categoriasInputRef}>
                    <input
                        type="button"
                        value="Todo"
                        onClick={() => handleClickCategoria('Todo')}
                        style={{
                            backgroundColor: categoriaSeleccionada === 'Todo' ? '#0c71cf' : '',
                            color: categoriaSeleccionada === 'Todo' ? '#fff' : '',
                            borderBottom: categoriaSeleccionada === 'Todo' ? '2px solid #0c71cf' : 'none'
                        }}
                    />
                    {categoriasConProductos.map(({ categoria, idCategoria }) => (
                        <input
                            key={idCategoria}
                            type="button"
                            value={categoria}
                            onClick={() => handleClickCategoria(idCategoria)}
                            style={{
                                backgroundColor: categoriaSeleccionada === idCategoria ? '#0c71cf' : '',
                                color: categoriaSeleccionada === idCategoria ? '#fff' : '',
                                borderBottom: categoriaSeleccionada === idCategoria ? '2px solid #0c71cf' : 'none'
                            }}
                        />
                    ))}
                </div>
            )}

            {loading ? (
                <ProductosLoading />
            ) : (
                <div className='Products'>
                    {categoriaSeleccionada === 'Todo' && (
                        <>
                            {productosParaMostrar?.some(item => item.masVendido === "si") && (
                                <div className='categoriSection'>
                                    <div className='deFlexTitlesection'>
                                        <h3>Más Vendidos</h3>
                                    </div>
                                    <Swiper
                                        effect={'coverflow'}
                                        grabCursor={true}
                                        slidesPerView={'auto'}
                                        id='swiper_container_products_improved'
                                        autoplay={{ delay: 3000 }}
                                    >
                                        {productosParaMostrar?.filter(item => item.masVendido === "si").map(item => (
                                            <SwiperSlide key={item.idProducto} className='swiper-slide-improved-masvendidos'>
                                                <ProductCard item={item} isMasVendido={true} />
                                            </SwiperSlide>
                                        ))}
                                    </Swiper>
                                </div>
                            )}

                            {categoriasConProductos?.map(({ categoria, idCategoria }) => (
                                <div key={idCategoria} className='categoriSection' ref={ref => categoriasRefs.current[categorias.findIndex(cat => cat.idCategoria === idCategoria)] = ref}>
                                    <div className='deFlexTitlesection'>
                                        <h3>{categoria}</h3>
                                        <button onClick={() => handleClickCategoria(idCategoria)}>
                                            Ver más
                                        </button>
                                    </div>

                                    <Swiper
                                        effect={'coverflow'}
                                        grabCursor={true}
                                        slidesPerView={'auto'}
                                        id='swiper_container_products_improved'
                                    >
                                        {productosParaMostrar?.filter(item => item.idCategoria === idCategoria).map(item => (
                                            <SwiperSlide key={item.idProducto} className='swiper-slide-improved'>
                                                <ProductCard item={item} />
                                            </SwiperSlide>
                                        ))}
                                    </Swiper>
                                </div>
                            ))}
                        </>
                    )}

                    <div className='categoriSectionSelected'>
                        {productosParaMostrar
                            ?.filter(item => categoriaSeleccionada !== 'Todo' && item.idCategoria === categoriaSeleccionada)
                            ?.map(item => (
                                <ProductCard key={item.idProducto} item={item} />
                            ))}
                    </div>
                </div>
            )}
        </div>
    );
}